import { BaseApiService } from './BaseApiService';
import {
  EligibleProduct,
  ExtractMeta,
  ForecastSeriesResponse,
  ForecastStatus,
  HolidayKey,
  SeasonViewResponse,
} from '../types/AiForecasting';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

class AiForecastingService extends BaseApiService {
  async getStatus(): Promise<ForecastStatus> {
    const payload = await this.get<ApiResponse<ForecastStatus>>(
      '/reports/production-forecast/status'
    );
    if (payload?.success && payload.data) {
      return payload.data;
    }
    throw new Error(payload?.message || 'Failed to load forecast status');
  }

  async getProducts(): Promise<{ extract_meta: ExtractMeta; products: EligibleProduct[] }> {
    const payload = await this.get<
      ApiResponse<{ extract_meta: ExtractMeta; products: EligibleProduct[] }>
    >('/reports/production-forecast/products');
    if (payload?.success && payload.data) {
      return payload.data;
    }
    throw new Error(payload?.message || 'Failed to load forecast products');
  }

  async getSeries(product_id: number, holiday_key?: HolidayKey): Promise<ForecastSeriesResponse> {
    const payload = await this.get<ApiResponse<ForecastSeriesResponse>>(
      '/reports/production-forecast/series',
      holiday_key ? { product_id, holiday_key } : { product_id }
    );
    if (payload?.success && payload.data) {
      return payload.data;
    }
    throw new Error(payload?.message || 'Failed to load forecast series');
  }

  async getSeasonView(holiday_key?: HolidayKey): Promise<SeasonViewResponse> {
    const payload = await this.get<ApiResponse<SeasonViewResponse>>(
      '/reports/production-forecast/season-view',
      holiday_key ? { holiday_key } : {}
    );
    if (payload?.success && payload.data) {
      return payload.data;
    }
    throw new Error(payload?.message || 'Failed to load season view');
  }

  async runExtract(
    lookback_years?: number
  ): Promise<{ extract_meta: ExtractMeta; product_count: number }> {
    const payload = await this.post<
      ApiResponse<{ extract_meta: ExtractMeta; product_count: number }>
    >('/reports/production-forecast/extract', lookback_years ? { lookback_years } : {});
    if (payload?.success && payload.data) {
      return payload.data;
    }
    throw new Error(payload?.message || 'Failed to run forecast extract');
  }
}

export const aiForecastingService = new AiForecastingService();
